var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_22",
  "data-name": "Ellipse 22",
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#f12f1a"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "close",
  d: "M4.733,4.136,7.848,1.021A.518.518,0,1,0,7.115.288L4,3.4.885.288a.518.518,0,0,0-.733.733L3.267,4.136.152,7.251a.518.518,0,1,0,.733.733L4,4.869,7.115,7.984a.518.518,0,0,0,.733-.733Zm0,0",
  transform: "translate(4 3.864)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/circle-cross.24877802.svg";
export { SvgComponent as ReactComponent };